import { render } from "./CitiesSettings.vue?vue&type=template&id=b479a37e&scoped=true"
import script from "./CitiesSettings.vue?vue&type=script&lang=js"
export * from "./CitiesSettings.vue?vue&type=script&lang=js"

import "./CitiesSettings.vue?vue&type=style&index=0&id=b479a37e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b479a37e"]])

export default __exports__